import React from 'react'
import {Box, Link, Text} from '@chakra-ui/react'
import {breadcrumbStyle, textStyle, linkStyle, separatorStyle} from './index.style'
import useSitePreference from '../../../../hooks/use-site-preference'
import PropTypes from 'prop-types'

const StoreBreadcrumbs = ({address1, city, state}) => {
    const {data} = useSitePreference('statesMapping')
    const statesList = data?.statesMapping

    const breadcrumbItems = [
        {label: 'HOME', url: '/', isLink: true},
        {label: 'FIND A STORE', url: '/storelocator/', isLink: true},
        {
            label: (statesList && statesList[state]) || '',
            url: `/storelocator/state/?dwfrm_storelocator_state=${state}`,
            isLink: true
        },
        {label: city || '', isLink: false},
        {label: address1 || '', isLink: false}
    ]

    return (
        <Box sx={breadcrumbStyle}>
            {breadcrumbItems.map((item, index) => (
                <React.Fragment key={index}>
                    {item.isLink ? (
                        <Link href={item.url} sx={{...linkStyle, ...textStyle}}>
                            {item.label}
                        </Link>
                    ) : (
                        <Text as="span" sx={textStyle}>
                            {item.label}
                        </Text>
                    )}
                    {index < breadcrumbItems.length - 1 && (
                        <Text as="span" sx={separatorStyle}>
                            {`//`}
                        </Text>
                    )}
                </React.Fragment>
            ))}
        </Box>
    )
}

export default StoreBreadcrumbs

StoreBreadcrumbs.propTypes = {
    address1: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string
}
